exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-horizontal[data-v-2db35d86]{max-width:300px;background-color:aqua}.col-sm-6[data-v-2db35d86]{padding-left:0}.submit[data-v-2db35d86]{margin:0}.form-control.invalid[data-v-2db35d86]{border:1px solid red;background-color:#facaca}.error-msg[data-v-2db35d86]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2db35d86","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Points.vue
// module id = 59
// module chunks = 0